import { render, staticRenderFns } from "./ReauthorizeView.vue?vue&type=template&id=96229a7c&"
import script from "./ReauthorizeView.vue?vue&type=script&lang=js&"
export * from "./ReauthorizeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports